import {BenchlingBlob} from 'schemas/tags/BlobConstants';

import {ResultBlobGraphQL} from '../../../graphql-fragments/results/__generated/ResultBlobGraphQL';

export function restBlobToGraphQL(blob: BenchlingBlob): ResultBlobGraphQL {
  return {
    __typename: 'ResultBlobNode',
    id: blob.id,
    name: blob.name,
    url: blob.url,
    previewFileJson: blob.previewFile,
    pdfPreviewFileJson: blob.pdfPreviewFile,
    uploadStatus: blob.uploadStatus ?? null,
  };
}
